import React, { FC } from 'react';
import { getAccumulatorFill } from '@beef/elk-common/utils';
import classNames from 'classnames/bind';

import {
  composeUnit,
  getMainTextVariant,
  getSecondaryTextVariant,
  getUnit,
  replaceDotWithComma,
} from 'utils/accumulators';

import type { AccumulatorProps } from './types';
import styles from './styles.pcss';
import { AccumulatorContentWrapper } from './AccumulatorContentWrapper';
import { BaseTextContent } from './TextContent/BaseTextContent';

const cn = classNames.bind(styles);

export const Accumulator: FC<AccumulatorProps> = ({
  accumulator: { isLow, rest, size, isUnlimited, sizeText, displayUnit },
  buttonSlot,
  hideProgress = false,
  isInline = false,
  isMobile = true,
  children,
  hasButton,
}) => {
  const fillPortion = getAccumulatorFill({ size, rest, isUnlimited });

  return (
    <div className={cn('container')}>
      {!hideProgress && (
        <div className={cn('filled', { low: isLow })} style={{ width: `${fillPortion * 100}%` }} />
      )}
      {buttonSlot}
      <AccumulatorContentWrapper isInline={isInline} withMarginRight={hasButton}>
        {children || (
          <BaseTextContent
            mainText={composeUnit(rest, getUnit(displayUnit || ''))}
            mainTextColor={isLow ? 'error' : 'primary'}
            mainTextVariant={getMainTextVariant(isInline, isMobile)}
            secondaryText={sizeText ?? (size ? `из ${replaceDotWithComma(size)}` : undefined)}
            secondaryTextColor="primary"
            secondaryTextVariant={getSecondaryTextVariant(isMobile)}
            shouldRender
          />
        )}
      </AccumulatorContentWrapper>
    </div>
  );
};
